/* Topspin Mart — on-the-fly racket assembly & gluing service.
 * Adds the gluing service to the cart when the customer opts in AND the cart has
 * both a blade (Ping pong rackets) and a rubber (Ping pong rubbers). Keeps the
 * quantity in sync (1 per blade), removes it if the build breaks, and renders a
 * cart-drawer upsell / confirmation note.
 *
 * FREEZE-SAFE DESIGN:
 *  - No childList/subtree observer on the drawer (that cascaded into render
 *    loops). Drawer UI is (re)injected on init, on cart:update, and on drawer
 *    open via an ATTRIBUTE-ONLY observer that can't self-trigger.
 *  - A cooldown after our own cart write stops the theme's echo from
 *    re-triggering our reconcile (the cause of the lock-up).
 *  - All cart writes are guarded by BUSY so they never stack/race. */
(function () {
  'use strict';
  var C = window.TS_GLUE;
  if (!C || !C.variantId) return;

  var VARIANT = Number(C.variantId);
  var BLADE = C.bladeType || 'Ping pong rackets';
  var RUBBER = C.rubberType || 'Ping pong rubbers';
  var ADD_URL = (C.routes && C.routes.add) || '/cart/add.js';
  var CHANGE_URL = (C.routes && C.routes.change) || '/cart/change.js';
  var T = C.t || {};
  var KEY = 'ts_glue_intent';
  var COOLDOWN = 900;

  var BUSY = false;
  var cooldownUntil = 0;
  var STATE = { blades: 0, rubbers: 0, glue: null, valid: false };
  var lastGlue = false;
  var syncTimer = null, injectTimer = null, ensureTimer = null;

  function now() { try { return Date.now(); } catch (e) { return (+new Date()); } }
  function intentOn() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setIntent(v) { try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function classify(cart) {
    var blades = 0, rubbers = 0, glue = null;
    var items = (cart && cart.items) || [];
    items.forEach(function (it) {
      if (Number(it.variant_id) === VARIANT) { glue = it; return; }
      if (it.product_type === BLADE) blades += it.quantity;
      else if (it.product_type === RUBBER) rubbers += it.quantity;
    });
    return { blades: blades, rubbers: rubbers, glue: glue, valid: blades > 0 && rubbers > 0 };
  }
  function cartSectionIds() {
    var ids = [];
    var els = document.querySelectorAll('cart-items-component[data-section-id]');
    for (var i = 0; i < els.length; i++) {
      var id = els[i].getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids.join(',');
  }
  function post(url, body) {
    BUSY = true;
    body.sections = cartSectionIds();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })['catch'](function () { return null; }).then(function (d) {
      BUSY = false;
      cooldownUntil = now() + COOLDOWN; /* ignore the echo our own write produces */
      return d;
    });
  }
  function addGlue(q) {
    return post(ADD_URL, { items: [{ id: VARIANT, quantity: q, properties: { '_ts_assembly': '1' } }] });
  }
  function setGlue(q) {
    return post(CHANGE_URL, { id: String(VARIANT), quantity: q });
  }
  function notifyCart(sections) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { source: 'ts-glue', data: { sections: sections || {} } }
      }));
    } catch (e) {}
  }

  function reconcile() {
    if (BUSY) return Promise.resolve();
    return getCart().then(function (cart) {
      var s = classify(cart);
      var intent = intentOn();

      /* user manually removed the glue line -> stop re-adding it */
      if (lastGlue && !s.glue && intent) { setIntent(false); intent = false; }

      var op = null;
      if (intent && s.valid) {
        var want = s.blades; /* one assembly (up to 2 rubbers) per blade */
        if (!s.glue) op = addGlue(want);
        else if (s.glue.quantity !== want) op = setGlue(want);
      } else if (s.glue) {
        op = setGlue(0); /* no intent or incomplete build -> remove */
      }

      if (op) {
        return op.then(function (res) {
          var sections = (res && res.sections) ? res.sections : {};
          return getCart().then(function (c2) {
            STATE = classify(c2);
            lastGlue = !!STATE.glue;
            notifyCart(sections);
            scheduleInject();
          });
        });
      }
      STATE = s;
      lastGlue = !!s.glue;
      scheduleInject();
    })['catch'](function () {});
  }
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { reconcile(); }, 250);
  }

  /* ---------- product page opt-in ---------- */
  function ensureOptin() {
    var tpl = document.getElementById('tsglue-template');
    if (!tpl || !tpl.content) return;
    if (document.getElementById('ts-glue-optin')) return;
    var anchor = document.querySelector('.buy-buttons-block');
    if (!anchor) {
      var atc = document.querySelector('.add-to-cart-button, button[name="add"]');
      anchor = atc ? (atc.closest('.buy-buttons-block, product-form-component, .product-form-buttons') || atc.parentNode) : null;
    }
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(tpl.content.cloneNode(true), anchor.nextSibling);
    var cb = document.getElementById('ts-glue-optin');
    if (cb) {
      cb.checked = intentOn();
      cb.addEventListener('change', function () { setIntent(cb.checked); reconcile(); });
    }
  }
  function scheduleEnsure() {
    clearTimeout(ensureTimer);
    ensureTimer = setTimeout(ensureOptin, 100);
  }

  /* ---------- cart drawer upsell / note ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function injectDrawer() {
    var anchors = document.querySelectorAll('.cart__ctas');
    if (!anchors.length) return;
    var s = STATE;
    var sig = s.glue ? 'note' : ((s.valid && !intentOn()) ? 'upsell' : 'none');
    for (var i = 0; i < anchors.length; i++) {
      var ctas = anchors[i];
      var container = ctas.parentNode;
      if (!container) continue;
      var existing = container.querySelector('.tsglue-drawer');
      if (existing && existing.getAttribute('data-sig') === sig) continue; /* already up to date */
      if (existing) existing.parentNode.removeChild(existing);
      if (sig === 'none') continue;
      var html = '';
      if (sig === 'note') {
        html = '<div class="tsglue-note">'
          + '<div class="tsglue-note__title">' + esc(T.noteTitle) + '</div>'
          + '<div class="tsglue-note__text">' + esc(T.noteText) + '</div>'
          + '<button type="button" class="tsglue-note__remove" data-tsglue-remove>' + esc(T.removeText) + '</button>'
          + '</div>';
      } else {
        html = '<button type="button" class="tsglue-upsell" data-tsglue-add>'
          + '<span class="tsglue-upsell__icon" aria-hidden="true">&#128296;</span>'
          + '<span class="tsglue-upsell__body">'
          + '<span class="tsglue-upsell__title">' + esc(T.drawerTitle) + '</span>'
          + '<span class="tsglue-upsell__sub">' + esc(T.drawerSub) + '</span>'
          + '</span>'
          + '<span class="tsglue-upsell__cta">+' + esc(C.priceText) + '</span>'
          + '</button>';
      }
      var node = document.createElement('div');
      node.className = 'tsglue-drawer';
      node.setAttribute('data-sig', sig);
      if (C.isAr) node.setAttribute('dir', 'rtl');
      node.innerHTML = html;
      container.insertBefore(node, ctas);
      var addBtn = node.querySelector('[data-tsglue-add]');
      if (addBtn) addBtn.addEventListener('click', function () { setIntent(true); reconcile(); });
      var rmBtn = node.querySelector('[data-tsglue-remove]');
      if (rmBtn) rmBtn.addEventListener('click', function () { setIntent(false); reconcile(); });
    }
  }
  function scheduleInject() {
    clearTimeout(injectTimer);
    injectTimer = setTimeout(injectDrawer, 120);
  }

  /* ---------- wiring ---------- */
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.source === 'ts-glue') { scheduleInject(); return; }
    /* during the cooldown after our own write, only refresh the UI — do NOT
       reconcile again (that echo loop is what froze the drawer). */
    if (now() < cooldownUntil) { scheduleInject(); return; }
    scheduleSync();
    scheduleInject();
  });
  document.addEventListener('variant:update', scheduleEnsure);
  document.addEventListener('shopify:section:load', function () { ensureOptin(); scheduleInject(); });
  window.addEventListener('pageshow', function () { ensureOptin(); reconcile(); });

  function boot() {
    ensureOptin();
    reconcile();

    /* ATTRIBUTE-ONLY observer on the cart dialog so the note/upsell shows when
       the drawer opens. Watches open/class/style only — never childList — so
       our own injection (a childList change) can't retrigger it. */
    var tries = 0;
    (function hookDrawer() {
      var dlg = document.querySelector('cart-drawer-component dialog')
        || document.querySelector('dialog.cart-drawer')
        || document.querySelector('cart-drawer-component');
      if (dlg) {
        try {
          new MutationObserver(function () { scheduleInject(); })
            .observe(dlg, { attributes: true, attributeFilter: ['open', 'class', 'style', 'aria-hidden'] });
        } catch (e) {}
        return;
      }
      if (tries++ < 12) setTimeout(hookDrawer, 400);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
